import { isUndefined } from "lodash";

import type { Order } from "../../../../../../../services";
import type { DateFns } from "../../../../../../../utils/DateFns";

const cellProcessing = (item: Order.Model, dateFns: DateFns): string => {
	const timestamp = item.executingStages?.with_clients?.timestamp;

	if (isUndefined(timestamp)) return "";

	return dateFns.formatTime2(timestamp, "HH:mm:ss");
};

export default cellProcessing;
